import * as $ from 'jquery';

$(document).on( 'click', '.sidebar-toggle', function () {
	$('.sider-wrapper').toggle();
 }); 

 $(document).on( 'click', '.open-dropdown', function () {
	$( this ).closest(".dropdown").toggleClass( 'opened' );
 }); 
$(document).on( 'click', '.selected-lang-en', function () { 
	$( this ).closest(".lang-select").addClass( 'en-lang' );
	$( this ).closest(".lang-select").removeClass( 'de-lang' );
});
$(document).on( 'click', '.selected-lang-de', function () {
	$( this ).closest(".lang-select").addClass( 'de-lang' );
	$( this ).closest(".lang-select").removeClass( 'en-lang' );
}); 
	
// $( ".cat-img-upload" ).click(function() {
$(document).on( 'click', '.cat-img-upload', function () {
    $("#cat-img").click();
});
// $( ".org-logo-upload" ).click(function() {
$(document).on( 'click', '.org-logo-upload', function () {
    $("#org-logo-img").click();
});
// $( "#upload-btn" ).click(function() {
$(document).on( 'click', '#upload-btn', function () {
    $("#upload-html").click();
});

var el = document.getElementById('cat-img');
if(el){
  
    el.addEventListener('change', function(){
  if (this.files[0] ) {
    var picture = new FileReader();
    picture.readAsDataURL(this.files[0]);
    picture.addEventListener('load', function(event) {
      document.getElementById('uploadedImage').setAttribute('src', event.target.result);
      document.getElementById('uploadedImage').style.display = 'block';
    });
  }
  $(".img-cat").hide();
});
}
  
var ell = document.getElementById('org-logo-img');
if(ell){
    ell.addEventListener('change', function(){
    if (this.files[0] ) {
        var picture = new FileReader();
        picture.readAsDataURL(this.files[0]);
        picture.addEventListener('load', function(event) {
        document.getElementById('orgLogo').setAttribute('src', event.target.result);
        document.getElementById('orgLogo').style.display = 'block';
        });
    }
    $(".logo-org").hide();
});
}

$(document).ready(function(){

	var current_fs, next_fs, previous_fs; //fieldsets
	var opacity;

	// $("#next").click(function(){
	$(document).on( 'click', '.next', function () {
		
	current_fs = $(this).parent();
	next_fs = $(this).parent().next();
	previous_fs = $(this).parent().prev();
	
	$("#progressbar .steps-li").eq($("fieldset").index(current_fs)).addClass("completed");
	//Add Class Active
	$("#progressbar li .progress-bar").eq($("fieldset").index(next_fs)).addClass("w-100");

	//show the next fieldset
	next_fs.show();
	//hide the current fieldset with style
	current_fs.animate({opacity: 0}, {
	step: function(now) {
	// for making fielset appear animation
	opacity = 1 - now;

	current_fs.css({
	'display': 'none',
	'position': 'relative'
	});
	next_fs.css({'opacity': opacity});
	},
	duration: 600
	});
	});

	$(document).on( 'click', '.previous', function () {

	current_fs = $(this).parent();
	previous_fs = $(this).parent().prev();

	$("#progressbar li .progress-bar").eq($("fieldset").index(current_fs)).removeClass("w-100");

	previous_fs.show();
	current_fs.animate({opacity: 0}, {
	step: function(now) {
	opacity = 1 - now;

	current_fs.css({
	'display': 'none',
	'position': 'relative'
	});
	previous_fs.css({'opacity': opacity});
	},
	duration: 600
	});
	});

	$('.radio-group .radio').click(function(){
	$(this).parent().find('.radio').removeClass('selected');
	$(this).addClass('selected');
	});

	// $(".submit").click(function(){
	// return false;
	// })

});